module.exports = __webpack_public_path__ + "img/step4.76d9c728.png";